<div class="event-feed-tile">
  <div class="header-image fading"></div>
  <div class="convention-details">
    <div class="title fading"></div>
    <div class="desc fading"></div>
  </div>
</div>
